import { AGENCY_DATA_INITIAL_STATE } from 'state/reducers/agencyManagement';

export default function createUserState(zohoData, firebaseData) {
  return {
    zohoData: createZohoData(zohoData),
    firebaseData,
    zohoId: zohoData.id
  };
}

export function createZohoData(zohoData) {
  const rawPhoto = zohoData.Agent_Photo;
  const agentPhoto = !rawPhoto || rawPhoto === 'null' ? '' : rawPhoto;

  return {
    ...zohoData,
    agencyData: zohoData.agencyData
      ? zohoData.agencyData
      : AGENCY_DATA_INITIAL_STATE,
    agentPhoto
  };
}
